export const locales = ['en', 'fr']
export const localeDefault = locales[1]
